module.exports = __webpack_public_path__ + "img/albert-pro.8235d05f.jpg";